import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import TemplatesPage from './pages/CreateDocument';
import FormPage from './pages/FormPage';
import DownloadPage from './pages/DownloadPage';
import DashboardPage from './pages/DashboardPage';
import DocumentViewPage from './pages/DocumentViewPage';
import ProfilePage from './pages/ProfilePage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import AuthModal from './components/auth/AuthModal';
import AuthCallback from './components/auth/AuthCallBack';
import PricingPage from './pages/PricingPage';
import FeaturesPage from './pages/FeaturesPage';
import PaymentSuccessPage from './pages/PaymentSuccessPage';
import PaymentCancelledPage from './pages/PaymentCancelledPage';

function App() {
  // Add visibility change handler
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // When tab becomes visible again, just preserve state if needed
        // but don't cause any navigations
        const currentPath = window.location.pathname;
        
        if (currentPath === '/templates') {
          const storedState = JSON.parse(sessionStorage.getItem('templatesPageState') || '{}');
          if (storedState.path === '/templates') {
            // Update stored state without affecting navigation
            const updatedState = {
              ...storedState,
              hasVisited: true
            };
            sessionStorage.setItem('templatesPageState', JSON.stringify(updatedState));
          }
        }
        
        // Add any other path-specific state preservation here if needed
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return (
    <Router>
      <AuthProvider>
        <div className="flex flex-col min-h-screen bg-background">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/createdocument" element={<TemplatesPage />} />
              <Route path="/templates" element={<TemplatesPage />} />
              <Route path="/form/:documentType" element={<FormPage />} />
              <Route path="/download" element={<DownloadPage />} />
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/document/:documentId" element={
                <ProtectedRoute>
                  <DocumentViewPage />
                </ProtectedRoute>
              } />
              <Route path="/document/:documentId/edit" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              <Route path="/profile" element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              } />
              <Route path="/auth/callback" element={<AuthCallback />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/features" element={<FeaturesPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
              <Route path="/payment-cancelled" element={<PaymentCancelledPage />} />
            </Routes>
          </main>
          <Footer />
          <AuthModal />
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;